import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};
class TruckForm {
	owner_name:string;
	truck_no : string;
	branch: string;
	pan_no: string;
	account_no: string;
	bank_name: string;
	bank_branch: string;
	bank_ifsc: string;
	
}


@Injectable()
export class TruckService {

	private url = environment.url;

	constructor(private http: HttpClient) { }


	addNewTruck(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/truck/submit', form, http_options);
	};

	getAllTruck(): Observable<TruckForm[]> {
		return this.http.get<TruckForm[]>(this.url + '/masters/truck/all');
	};
	getTruckFormWith(name:string): Observable<TruckForm[]> {
		console.log (this.http.get<TruckForm[]>(this.url + '/masters/truck/get/' + name));
		return this.http.get<TruckForm[]>(this.url + '/masters/truck/get/' + name);
	};
}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/truck.service.ts